import React from 'react';
import styles from './transparentLoadingIndicator.module.scss';
import { Loader } from '@qwealth/qcore';

const TransparentLoadingIndicator = (props) => {
	return (
		<div className={styles.loadingIndicatorContainer} style={{ minHeight: props.height ? props.height : '200px' }}>
			<Loader size={props.size ? props.size : 'small'} />
		</div>
	);
};

export default TransparentLoadingIndicator;
